var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLiveChat = function SvgLiveChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "live_chat_svg2__a",
    x1: 13.7,
    x2: 200.89,
    y1: 169.69,
    y2: -6.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#live_chat_svg2__a",
    id: "live_chat_svg2__c",
    x1: 2.66,
    x2: 189.86,
    y1: 157.99,
    y2: -18.59
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#live_chat_svg2__a",
    id: "live_chat_svg2__d",
    x1: 13.7,
    x2: 200.89,
    y1: 169.69,
    y2: -6.89
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#live_chat_svg2__a",
    id: "live_chat_svg2__e",
    x1: 24.73,
    x2: 211.93,
    y1: 181.38,
    y2: 4.81
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#live_chat_svg2__a",
    id: "live_chat_svg2__f",
    x1: 13.7,
    x2: 200.89,
    y1: 169.69,
    y2: -6.89
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M182.42 58.98h-12.08a76.9 76.9 0 0 0-17.32-25.33c-11.74-11.38-26.93-18.79-42.78-20.87-26.27-3.45-52.01 6.61-68.87 26.91a76.6 76.6 0 0 0-11.68 19.29H17.57c-9.69 0-17.58 7.89-17.58 17.58V100c0 9.69 7.89 17.58 17.58 17.58h24l-2.51-7.68c-7.31-22.38-3.19-45.24 11.32-62.72 14.27-17.19 36.07-25.7 58.32-22.78 27.87 3.66 50.44 25.55 54.88 53.23 3.03 18.89-2.26 37.97-14.51 52.36-12.28 14.42-30.14 22.71-49 22.74-9.74.01-17.67 7.9-17.67 17.58s7.89 17.58 17.58 17.58 17.58-7.89 17.58-17.58v-7.92c15.61-3.71 29.8-12.3 40.44-24.8a75.8 75.8 0 0 0 12.3-20.02h12.11c9.69 0 17.58-7.89 17.58-17.58V76.55c0-9.69-7.89-17.58-17.58-17.58ZM25.81 105.86h-8.23c-3.23 0-5.86-2.63-5.86-5.86V76.56c0-3.23 2.63-5.86 5.86-5.86h8.3c-.21.88-.4 1.76-.58 2.65-2.14 10.72-1.96 21.62.51 32.51m80.05 64.45c0 3.23-2.63 5.86-5.86 5.86s-5.86-2.63-5.86-5.86 2.68-5.86 5.97-5.86c1.93 0 3.85-.08 5.75-.22zM188.28 100c0 3.23-2.63 5.86-5.86 5.86h-8.3c2.33-9.79 2.68-19.89 1.05-30.08a69 69 0 0 0-1.01-5.08h8.26c3.23 0 5.86 2.63 5.86 5.86z",
    style: {
      fill: "url(#live_chat_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7 82.42h11.72v11.72H70.7z",
    style: {
      fill: "url(#live_chat_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.14 82.42h11.72v11.72H94.14z",
    style: {
      fill: "url(#live_chat_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.58 82.42h11.72v11.72h-11.72z",
    style: {
      fill: "url(#live_chat_svg2__e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.27 129.29v11.72H100c29.08 0 52.73-23.66 52.73-52.73S129.07 35.55 100 35.55 47.27 59.21 47.27 88.28c0 11.85 3.98 23.31 11.26 32.57-1.41 4.94-5.92 8.44-11.26 8.44M100 47.26c22.62 0 41.02 18.4 41.02 41.02S122.62 129.3 100 129.3H67.57c1.68-2.91 2.72-6.16 3.04-9.56l.23-2.51-1.66-1.89a40.98 40.98 0 0 1-10.19-27.06c0-22.62 18.4-41.02 41.02-41.02Z",
    style: {
      fill: "url(#live_chat_svg2__f)",
      strokeWidth: 0
    }
  }));
};
export default SvgLiveChat;